import { wsService } from "./wsService";

const section = "rules/reposicion";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function download_excel(param = {}) {
  return wsService.make_post_request(section + "/get-sample-excel", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

function generar_reposicion(param = {}) {
  return wsService.make_post_request(section + "/generar-reposicion", param);
}

function generar_reposicion_estado(param = {}) {
  return wsService.make_post_request(section + "/generar-reposicion-estado", param);
}

//Simula (dry_run: true) o aplica las politicas de reposicion. Corre en background:
//el estado se consulta con politicas_estado.
function aplicar_politicas(param = {}) {
  return wsService.make_post_request(section + "/aplicar-politicas", param);
}

function politicas_estado(param = {}) {
  return wsService.make_post_request(section + "/politicas-estado", param);
}

//Detalle del ultimo resultado, paginado en el server: {from, limit, accion, demanda, con_observaciones, search, sort_by, sort_desc}
function politicas_detalle(param = {}) {
  return wsService.make_post_request(section + "/politicas-detalle", param);
}

//Historial de cambios que las politicas le hicieron a una regla ({rule_id}) o producto ({product: {id}})
function politicas_log(param = {}) {
  return wsService.make_post_request(section + "/politicas-log/list", param);
}

const ORIGEN_MANUAL = "M";
const ORIGEN_POLITICA = "P";

const ORIGENES = [
  { id: ORIGEN_MANUAL, name: "Manual" },
  { id: ORIGEN_POLITICA, name: "Política" },
];

export const reposicionRuleService = {
  section,
  filter,
  get,
  remove,
  create,
  update,
  download_excel,
  import_line_excel,
  generar_reposicion,
  generar_reposicion_estado,
  aplicar_politicas,
  politicas_estado,
  politicas_detalle,
  politicas_log,
  ORIGEN_MANUAL,
  ORIGEN_POLITICA,
  ORIGENES,
};
